import orderService from "../../services/order-service"
import Payables from '../Account/Payables/Payables.vue'
import {mapState} from 'vuex'
import router from '../../router/index.js'

export default {
    name: 'Success',
    components: {
        Payables
    },
    data() {
        return {
            order: {}
        }
    },
    methods: {
        async fetchOrder() {
            const response = await orderService.getSpecificOrder(this.$route.params.id)
            if (!response.error) {
                this.order = response.data
            }
        },
        newOrder() {
            router.push({ name: 'Home' })
        }
    },
    computed: {
        ...mapState({
            user: state => state.account.user
        }),
        directPayLink(){
            return `https://bunq.me/pixelhobby?amount=${this.order.total_price}&description=retailers%20order%20${this.order.id}`
        }  
    },
    created() {
        this.fetchOrder()
        this.$store.dispatch('account/getUser');
        this.$gtag.screenview({
            app_name: 'Retailers',
            screen_name: 'Success',
        })
    },
}